module.exports = __webpack_public_path__ + "static/media/customer-8.ba8b52ca.jpg";